// import Attendance from "./Attendance";

export default {
  // component: Attendance,
  priority: 850,
  path: "attendance",
  permissions: ["TimeAttendanceMenu/"], // ["ReportsMenu", "DeviceListMenu", "DeviceChartMenu", "ClockingMenu", "WorkingHourMenu", "CalendarMenu"
  // ,"ShiftDefinitionMenu", "PositionsMenu", "WritMenu", "PolicyDefinitionMenu", "SettingDefinitionMenu", "StackRulesMenu", "StackHistoryMenu"],
  name: app.translate("routes.home.Attendance"),
  icon: "av-timer",
  drawer: true,
};
